import styled from "styled-components";

interface iImageHeaderProps {
    brandBanner: string[];
}

export interface iTextColorProps {
    textColor: string;
}

export const Container = styled.div`
    height: 100%;
    width: 100%;
    background-color: ${props => props.theme.colors.neutral1.pure};
    position: relative;
    .notFound-svg{
        margin: 0 10px;
    }
    font-family: 'Galano Grotesque Alt';
`

export const ImageHeader = styled.div<iImageHeaderProps>`
    overflow: hidden;

    img{
        content:  ${props => `url(${props.brandBanner[0]})`};
        max-width:100%;
        min-width:100vw;
    }
    
    @media(min-width: 480px) {
        img{
            content:  ${props => `url(${props.brandBanner[1]})`};
        }
    }
    
`
export const Content = styled.div<iTextColorProps>`
    padding: 20px 1px;
    color: ${props => props.textColor};
    padding-bottom: 30px;
    h2{
        margin-bottom: 8px; 
        text-align: center;
        font-weight: normal;
    }
    p{
        text-align: justify;
    }
    .bio{
        display:flex;
        justify-content: center;
    }
    p:nth-child(3){
        margin-bottom: 20px;
        white-space: pre-wrap;
    }
    
    @media(min-width:768px) {
        padding: 18px 40px;
    }  



    .navigationWishlist {
        display: flex;
        gap: 20px;
        justify-content: center;
    }
    
    .navigationWishlistContent{
        border: 1px solid #000;
        display: flex;
        flex-direction: column;
        font-size: 0.8rem;

        .amount{
            font-size: 0.7rem;
        }
    }

`

export const SeparateLine = styled.div`
    border-top: 1px solid #E5E5E5;
    padding-bottom: 50px;
    width: 95%;
    margin: auto;
`
export const WithoutProductsMessage = styled.div`
    width: 95%;
    margin: auto;
    font-size: 1.6rem;
    color: #333333;
    text-align: center;
    line-height: 2.2rem;
    padding-bottom: 50%;
    h4{
        font-weight: normal;
    }
    p{
        font-size: 1.1rem;
        text-align: center;
    }
    @media screen and (min-width: 480px) and (max-width: 767px) {
        padding-bottom: 30%;
    }
    @media screen and (min-width: 768px) and (max-width: 1023px){
        padding-bottom: 65%;
    }
    @media(min-width:1024px) {
        padding-bottom: 10%;
    }  
    @media(min-width:768px) {
        width: 45%;
    }  
`



